/* Bestsellers panel — tile sizing + seamless image fill.
   Loaded AFTER luma-nav.js so these win.
   The product photo fills the tile edge to edge, so the seamless studio
   background IS the tile background and every card reads identical — the
   same effect Allies get from shooting everything on black.
   max-height keeps the whole panel, CTA included, inside one screen. */
(function(){
var s=document.createElement('style');
s.textContent=
'#lnmega{padding:0 0 20px!important}'+
'#lnmega .lngrid{max-width:620px!important;margin:0 auto!important;gap:10px!important;padding:12px 0 0!important}'+
'#lnmega .lnim{aspect-ratio:4/5!important;max-height:340px!important;background:#fafafa!important}'+
'#lnmega .lnim:after{display:none!important}'+
'#lnmega .lnim img{width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;object-fit:cover!important;mix-blend-mode:normal!important}'+
'#lnmega .lnmeta{padding:13px 1px 0!important}'+
'#lnmega .lnt{font-size:13px!important;margin-bottom:6px!important}'+
'#lnmega .lns{font-size:12.5px!important;margin-bottom:5px!important}'+
'#lnmega .lncta{margin-top:16px!important}'+
'#lnmega .lncta a{font-size:10.5px!important;padding:13px 30px!important}'+
'@media(max-width:760px){#lnmega .lngrid{max-width:none!important;padding:8px 8px 0!important}}';
document.head.appendChild(s);
})();